/* eslint-disable max-lines-per-function */
import React from "react";
import { Card, CardContent, Grid, IconButton } from "@material-ui/core";
import { Edit } from "@material-ui/icons";
import { PropertyUseCaseType } from "./use-case-form";
import UseCaseDetailsShort from "./use-case-details-short";

type UseCaseItemActionsType = {
  editUseCase: () => void
}

const UseCaseItemActions: React.FC<UseCaseItemActionsType> = ({ editUseCase }) => (
  <IconButton color="primary" size="small"
    onClick={editUseCase}
  >
    <Edit />
  </IconButton>
);

const UseCaseItem: React.FC<{
  useCase: PropertyUseCaseType,
  openEdit: () => void
}> =
({ useCase, openEdit }) => <>
  <Card variant="outlined">
    <CardContent>
      <Grid container>
        <UseCaseDetailsShort useCase={useCase} />
        <Grid item container xs={12} sm={3} xl={2} justifyContent="flex-end" alignContent="center">
          <UseCaseItemActions
            editUseCase={openEdit}
          />
        </Grid>
      </Grid>
    </CardContent>
  </Card>
</>;

export default UseCaseItem;
